import { Entity } from "@/core/entities/Entity"
import { Optional } from "@/core/types/Optional"

export enum OriginStatus {
  ACTIVE = 'ACTIVE',
  DISABLED = 'DISABLED'
}

export enum OriginType {
  TRUCK = 'TRUCK',
  KIOSK = 'KIOSK'
}
export interface OriginProps {
  name: string
  status: OriginStatus
  type: OriginType
  createdAt: Date
  updatedAt?: Date | null
}

export class Origin extends Entity<OriginProps> {
  get name() {
    return this.props.name
  }

  set name(name: string) {
    this.props.name = name
    this.touch()
  }

  get status() {
    return this.props.status
  }

  changeStatus() {
    switch (this.props.status) {
      case OriginStatus.ACTIVE:
        this.props.status = OriginStatus.DISABLED
        break
      case OriginStatus.DISABLED:
        this.props.status = OriginStatus.ACTIVE
        break
      default:
        this.props.status = OriginStatus.ACTIVE
    }
    this.touch()
  }

  get type(){
    return this.props.type
  }

  get createdAt() {
    return this.props.createdAt
  }

  get updatedAt() {
    return this.props.updatedAt
  }

  private touch() {
    this.props.updatedAt = new Date()
  }

  static create(
    props: Optional<OriginProps, 'createdAt' | 'status'>,
    id?: string,
  ) {

    const origin = new Origin(
      {
        ...props,
        status: props.status ?? OriginStatus.ACTIVE,
        createdAt: props.createdAt ?? new Date(),
      },
      id,
    )

    return origin
  }
}